<template>
  <div class="full-width px-4 mb-4">
    <v-text-field
      v-model="search"
      class="search-field"
      :label="searchLabel"
      prepend-inner-icon="icon-search"
      clearable
      outlined
      rounded
      :hide-details="true"
      :readonly="isLoading"
      @input="onSearchHandler"
    ></v-text-field>
  </div>
</template>

<script>
import { debounce } from "@/helpers/helpers";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

export default {
  name: "ReviewsCategoriesTableWrapper",
  props: {
    searchLabel: {
      type: String,
      default: "Search"
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    searchParamName: {
      type: String,
      default: "search"
    }
  },
  data() {
    return {
      search: ""
    };
  },
  methods: {
    onSearchHandler: debounce(async function() {
      if (this.search && this.search.length < 3) {
        return;
      }
      this.$emit("change", {
        [this.searchParamName]: this.search
      });
      const isDetailsPage = this.$route.name === "reviews-category-details";
      this.$gtm.trackCustomEvent({
        event: isDetailsPage
          ? GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_DETAILS_TABLE_SEARCH
          : GTM_EVENT_NAME.REVIEW_CATEGORY_ANALYTICS_OVERVIEW_TABLE_SEARCH,
        query: this.search
      });
    }, 500)
  }
};
</script>
<style lang="scss" scoped>
.search-field {
  ::v-deep .v-label {
    color: $primary;
  }
}
</style>
